import { Link } from "react-router-dom";
import { Phone, ArrowRight, MapPin } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, IMAGES } from "../../data/content";
import { BookButton } from "../BookButton";
import { SocialLinks } from "../SocialLinks";

const ctaBase =
  "w-full inline-flex items-center justify-center gap-2 rounded-sm px-8 py-4 font-semibold text-base transition-[transform,background-color,border-color,color] duration-200 hover:-translate-y-0.5 active:scale-[0.98]";

export const Hero = () => (
  <section className="relative flex items-center lg:min-h-[92vh]" data-testid="hero-section">
    <div className="absolute inset-0">
      <img src={IMAGES.hero} alt="Mobile mechanic working on a car engine in Las Vegas" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-black/60" />
    </div>

    <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 w-full">
      <img
        src="/logo-white.png"
        alt=""
        aria-hidden="true"
        className="hidden lg:block absolute right-12 top-1/2 -translate-y-1/2 h-[420px] w-auto opacity-90 drop-shadow-[0_0_40px_rgba(0,0,0,0.8)] pointer-events-none"
      />
      <div className="max-w-xl animate-fade-up">
        <div className="inline-flex items-center gap-2 border border-blue-500/40 bg-blue-500/10 rounded-full px-4 py-1.5 mb-8">
          <MapPin className="h-3.5 w-3.5 text-blue-400" />
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400">Serving the Las Vegas Valley</span>
        </div>

        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-none text-white mb-6">
          Mobile Mechanic Serving<br />
          <span className="text-blue-500">Las Vegas &amp; Henderson</span>
        </h1>

        <p className="text-base sm:text-lg text-zinc-300 leading-relaxed mb-10 max-w-xl">
          Mason's Mobile brings professional auto repair directly to your home,
          workplace or vehicle throughout the Las Vegas Valley — shop-quality
          service at prices lower than traditional repair shops and dealerships.
        </p>

        <div className="flex flex-col gap-3 max-w-sm">
          <a
            data-testid="hero-call-button"
            href={PHONE_TEL}
            className={`${ctaBase} bg-blue-600 hover:bg-blue-700 text-white shadow-lg shadow-blue-600/25`}
          >
            <Phone className="h-5 w-5" /> Call Now {PHONE_DISPLAY}
          </a>
          <Link
            data-testid="hero-request-service-button"
            to="/contact"
            className={`${ctaBase} border border-zinc-500 hover:border-white text-white`}
          >
            Request Service <ArrowRight className="h-5 w-5" />
          </Link>
          <BookButton className="w-full justify-center !px-8 !py-4 !text-base hover:-translate-y-0.5 active:scale-[0.98]" />
        </div>

        <p className="mt-6 text-zinc-400 text-sm tracking-wide" data-testid="hero-trust-statement">
          Transparent Pricing <span className="text-blue-500">•</span> Honest Repairs <span className="text-blue-500">•</span> Quality Work
        </p>

        <div className="mt-12" data-testid="hero-reviews-section">
          <h2 className="font-heading text-base md:text-lg font-semibold text-white">See Our Reviews</h2>
          <p className="text-zinc-500 text-sm mt-1 mb-4">Trusted by customers on Google &amp; Facebook.</p>
          <SocialLinks />
        </div>
      </div>
    </div>
  </section>
);
